module.exports = __webpack_public_path__ + "static/media/u1F913.3aa51e12.webp";